<script setup lang="ts">
import NavigationSection from "@/widgets/navigation/ui/NavigationSection.vue";
import Footer from "@/widgets/footer/ui/Footer.vue";
</script>

<template>
    <section class="flex flex-col justify-center items-center w-full h-full bg-background-tertiary">
        <NavigationSection />
        <div class="h-full overflow-y-auto w-[120rem] min-h-[94rem]">
            <slot></slot>
        </div>
        <Footer />
    </section>
</template>
